<template>
  <div>
    <div class="md-layout">
      <div
        v-for="sensor in sensores"
        :key="sensor.id"
        class="md-layout-item md-gutter md-small-size-50 md-size-33 mb-2"
      >
        <md-card>
          <md-ripple>
            <div class="md-layout m-2">
              <div class="md-layout-item md-size-65">
                <div class="md-title" style="font-size: 1.2rem">
                  {{ sensor.codigoIntegracao }}
                </div>
                <div class="md-subhead">
                  {{ sensor.descricao }}
                </div>
              </div>

              <div class="md-layout-item">
                <show-status
                  :value="sensor.calibracao.status"
                  :config="{
                    0: { label: 'Aguardando', color: '#FF9800' },
                    1: { label: 'Executado', color: '#4CAF50' },
                    2: { label: 'Cancelado', color: '#F44336' },
                    3: { label: 'Enviado', color: '#2196F3' },
                    4: { label: 'Não Enviado', color: '#949494' },
                    5: { label: 'Expirado', color: '#545454' },
                  }"
                />
              </div>
            </div>

            <md-card-actions>
              <!--                            <md-button @click="() => handleEnviar(sensor.id)">Enviar</md-button>-->
            </md-card-actions>
          </md-ripple>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import ShowStatus from '@/components/ShowStatus.vue'

export default {
  name: 'AcompanhamentoConfiguracaoSensor',
  components: { ShowStatus },
  props: {
    sensores: Array,
  },
  methods: {
    handleEnviar(id) {
      this.$emit('enviar', id)
    },
  },
}
</script>

<style scoped lang="scss"></style>
